// Export i18n configuration and utilities
import i18n from './config';
import { useTranslation } from 'react-i18next';

export default i18n;
export { useTranslation };

// Helper function to get translation with fallback
export const t = (key, options = {}) => {
  return i18n.t(key, options);
};

// Helper to change language (though we only support Hebrew)
export const changeLanguage = (lng) => {
  return i18n.changeLanguage(lng);
};

// Get current language
export const getCurrentLanguage = () => {
  return i18n.language || 'he';
};

// Check if current language is RTL
export const isRTL = () => {
  const currentLang = getCurrentLanguage();
  return currentLang === 'he';
};

